export default __webpack_public_path__ + "static/gabarito-categoria-SR-6791571190bab594d3581cc93ee6b6bf.pdf";